import { useMutation, useQueryClient } from "@tanstack/react-query";

import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useAddOrderItem = (orderId: number, fairId: number) => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      amount,
      productOfferingId,
    }: {
      amount: number;
      productOfferingId: number;
    }) => {
      return fetch(`${API}/api/semeadora/orders/${orderId}/items/`, {
        method: "POST",
        body: {
          amount,
          product_offering_id: productOfferingId,
        },
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      queryClient.invalidateQueries({ queryKey: ["farmerOrders"] });
      queryClient.invalidateQueries({ queryKey: ["product-offerings"] });
      queryClient.invalidateQueries({
        queryKey: ["product-offerings-all", fairId],
      });
    },
  });
};

export default useAddOrderItem;
